import React from 'react';

import { Text } from '@opendoor/bricks/core';

type HelperTextProps = {
  error?: boolean;
  children: React.ReactNode;
};

const HelperText: React.FC<HelperTextProps> = ({ error, children }) => (
  <Text color={error ? 'error500' : 'warmgrey800'} size="100">
    {children}
  </Text>
);

export default HelperText;
